import * as React from "react";
const SvgPause = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 39, height: 48, fill: "none", viewBox: "0 0 39 48", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M13.5 0H0v48h13.5V0zM39 0H25.5v48H39V0z" }));
export default SvgPause;
